import { render, staticRenderFns } from "./VatInvoiceListV2.vue?vue&type=template&id=1a661e36"
import script from "./VatInvoiceListV2.vue?vue&type=script&lang=js"
export * from "./VatInvoiceListV2.vue?vue&type=script&lang=js"
import style0 from "./VatInvoiceListV2.vue?vue&type=style&index=0&id=1a661e36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports